import loadJs from "fg-loadjs";
import _map from "lodash/map";
import _pickBy from "lodash/pickBy";
//

function buildUrl(url, query) {
  query = _pickBy(query, value => !!value);
  query = _map(query, (value, name) => `${name}=${value}`);

  return url + "?" + query.join("&");
}

const CACHE = {};

function promiseLib(libName, libUrl, query) {
  let lib = CACHE[libName];

  if (!lib) {
    lib = CACHE[libName] = new Promise((resolve, reject) => {
      loadJs(buildUrl(libUrl, query), () => {
        resolve({
          lib: window[libName],
          libName
        });
      });
    });
  }

  return lib;
}

export default function loadScript(libName, libUrl, query) {
  return promiseLib(libName, libUrl, query);
}
